import { create } from 'zustand';
import useVoyagerStore from '../stores/useVoyagerStore';
import { useSimpleSidebar } from './simpleSidebarState';

/** The phone drawer the sidebar lives in (#765, #1503): open or not. */
interface ChatSidebarState {
  drawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
}

export const useChatSidebar = create<ChatSidebarState>((set) => ({
  drawerOpen: false,
  setDrawerOpen: (drawerOpen) => set({ drawerOpen }),
}));

/** Below this width the sidebar is a drawer and the rail a top strip. */
export const PHONE_QUERY = '(max-width:860px)';

/**
 * New question (#765) — the rail's Home, the sidebar's button and ⌘K: the
 * New-chat screen, with its composer focused. The conversation on screen is
 * parked, not ended: a run in flight keeps going (`parkedConversations`).
 */
export function startNewQuestion(): void {
  const s = useVoyagerStore.getState();
  if (s.currentView !== 'landing') s.navigateToLanding();
  else useVoyagerStore.setState({ objectiveSpaceId: null, landingSurface: 'home' });
  s.clearLandingChat();
  useChatSidebar.getState().setDrawerOpen(false);
  // the simplified app's placeholder pages (#1503) give way to the New-chat screen; never set with the flag off
  useSimpleSidebar.getState().showPlaceholder(null);
  window.setTimeout(() => document.querySelector<HTMLTextAreaElement>('[data-testid="new-chat"] textarea')?.focus(), 0);
}
